import React, {useState} from 'react';
import menuItems from './menuItems';
import './SubHeader.scss';
import {useFilter} from "../../pages/Marketplace/FilterContext";

const SubHeader = ({filterParams,fetchFilteredProducts}) => {
    const {filterCategoryId, handleCategoryChange} = useFilter();
    const [subMenuItem, setSubMenuItem] = useState( '');
    const [marketplaceMenuItem, setMarketplaceMenuItem] = useState(null);

    const handleMenuClick = (item) => {
        if (['119', '120', 'healthcare'].includes(item)) {
            if (filterCategoryId === item) {
                setSubMenuItem('')
                handleCategoryChange('')
            } else {
                setSubMenuItem('')
                handleCategoryChange(item)
            }
        } else {
            if (subMenuItem === item) {
                setSubMenuItem('')
            } else {
                setSubMenuItem(item)
                fetchFilteredProducts({...filterParams, filterCategoryId: item, page: '1'});
            }
        }
            if (item === filterCategoryId || item === "healthcare") {
                handleCategoryChange('');
            } else if (['119', '120'].includes(item)) {
                handleCategoryChange(item);
            } else if (item === subMenuItem) {
                setSubMenuItem('');
                fetchFilteredProducts({...filterParams, filterCategoryId: '', page: '1'});
            } else {
                setSubMenuItem(item);
                fetchFilteredProducts({...filterParams, filterCategoryId: item, page: '1'});
            }
    };

    const marketplaceMenuClick = (menuItem) => {
        setMarketplaceMenuItem(prevMarketplaceMenuItem => {
            if (prevMarketplaceMenuItem === menuItem) {
                return null;
            } else {
                return menuItem;
            }
        });
    };

    return (
        <div className="sub-header">
            <div className="sub-menu">
                <div className="name-section">
            <span className="sub-menu-toggler " onClick={() => marketplaceMenuClick('marketplace')}>
                Marketplace
                <i className={`dropdown-arrow chevron-down _active ${marketplaceMenuItem === 'marketplace' ? 'active' : 'active'}`}></i>
            </span>
                </div>
                <ul id="js-dropdown-menu"
                    className={`sub-menu-list ${marketplaceMenuItem === 'marketplace' ? '' : 'sub-menu-list-active'}`}>
                    {menuItems.map((menuItem) =>
                        <li key={menuItem.id} className="sub-menu-item parent">
                            <div
                               className={`sub-menu-item-link link ${menuItem.id !== 'healthcare' && filterCategoryId === menuItem.id ? 'active' : ''}`}
                               onClick={() => handleMenuClick(menuItem.id)}>{menuItem.label}</div>
                            <i className={`dropdown-arrow chevron-down ${menuItem.id !== 'healthcare' && filterCategoryId === menuItem.id ? 'active' : ''}`}></i>
                            <ul className={`parent-list ${filterCategoryId === menuItem.id ? 'parent-list-active' : ''} ${menuItem.id === 'healthcare' ? 'hide-desktop' : ''}`}>
                                {menuItem.submenu.map((oneSubmenuItem) =>
                                    <li key={oneSubmenuItem.id} className="parent-item" onClick={() => handleMenuClick(oneSubmenuItem.id)}>
                                        <div
                                            className={`parent-link link ${subMenuItem === oneSubmenuItem.id ? 'active' : ''}`}
                                        >{oneSubmenuItem.label}</div>
                                    </li>
                                )}
                            </ul>
                        </li>
                    )}
                </ul>
            </div>
        </div>
    );
}

export default SubHeader;
